var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconImprovement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 70,
    viewBox: "0 0 73 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.9602 26.265C66.1675 26.265 72.0102 20.4224 72.0102 13.215C72.0102 6.00772 66.1675 0.165039 58.9602 0.165039C51.7528 0.165039 45.9102 6.00772 45.9102 13.215C45.9102 20.4224 51.7528 26.265 58.9602 26.265Z",
    fill: "#FE6571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6602 28.8451H49.1102C48.3692 28.829 47.6521 29.1073 47.116 29.6191C46.5799 30.1308 46.2685 30.8342 46.2502 31.5751V39.6551C46.2424 40.0229 46.1622 40.3855 46.0142 40.7222C45.8663 41.0589 45.6534 41.3632 45.3878 41.6177C45.1222 41.8721 44.8091 42.0717 44.4663 42.2051C44.1236 42.3385 43.7579 42.4031 43.3902 42.3951H25.4702C24.7378 42.3923 24.0335 42.6765 23.5082 43.1868C22.9829 43.6972 22.6785 44.393 22.6602 45.1251V53.1251C22.6418 53.866 22.3305 54.5695 21.7943 55.0812C21.2582 55.5929 20.5411 55.8712 19.8002 55.8551H9.52016C9.15161 55.8472 8.78512 55.9121 8.44171 56.0461C8.0983 56.1801 7.78474 56.3806 7.51902 56.6362C7.25329 56.8917 7.04064 57.1971 6.89325 57.535C6.74587 57.8729 6.66665 58.2366 6.66016 58.6051V66.6851C6.67851 67.4287 6.99091 68.1347 7.52889 68.6483C8.06687 69.1619 8.78654 69.4412 9.53016 69.4251H67.6602C68.4038 69.4412 69.1234 69.1619 69.6614 68.6483C70.1994 68.1347 70.5118 67.4287 70.5302 66.6851V31.5751C70.5211 31.2074 70.4396 30.8451 70.2905 30.5088C70.1413 30.1726 69.9273 29.869 69.6608 29.6155C69.3943 29.3619 69.0804 29.1634 68.7371 29.0312C68.3938 28.8991 68.0279 28.8358 67.6602 28.8451Z",
    fill: "#FE6571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.02022 60.4852C0.770218 54.0352 4.33022 41.7752 8.85022 39.0152C17.3702 33.7852 20.0402 54.0152 15.0602 53.9452C8.89022 53.9452 14.0602 39.3352 18.2702 33.3052C28.5802 18.6752 38.4202 24.7952 40.2102 30.0952C41.5902 34.1852 40.4402 40.4752 37.3402 40.3952C33.8902 40.3052 33.2702 34.8752 34.5202 30.6752C36.9902 22.3452 44.4502 15.0952 49.4202 12.3452",
    stroke: "#092C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6602 22.735C53.1841 24.7373 56.3531 25.7474 59.5702 25.575C63.9502 25.485 66.4302 23.875 69.0002 21.415",
    stroke: "#092C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72.01,
    height: 69.25,
    fill: "white",
    transform: "translate(0 0.165039)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImprovement);
export default __webpack_public_path__ + "static/media/icon-improvement.a8b98eed28e9e49f08cb300b63563a84.svg";
export { ForwardRef as ReactComponent };